import { Stack } from 'expo-router';

import { useAuthStackOptions } from '../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function AuthLayout() {
  const options = useAuthStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen name="join-or-sign-in/index" options={options.JoinOrSignIn as any} />
    </Stack>
  );
}
